import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Loader } from '@home-loan-experts/ui-helper';
import { Field, Formik, Form } from "formik";
import { enquiryValidationSchema } from "../../utils/equiryFormValidation";
import { mapEnquiryDetails, isEmpty } from "../../utils";
import { enquiry } from "../../api/enquiryApi";
import { toast } from "react-toastify";
import Notice from "../common/Notice";
import { EQUIRY_SENT_NOTICE } from "../../constants";
import { eventTrackingHelper } from "../../utils/gtmTrackerHelper";

const EnquiryForm = () => {
    const [form, setForm] = useState(true);
    const postcodeData = useSelector((state) => state.postcode);

    const handleSubmit = async (enquiryValues, { resetForm, setSubmitting }) => {
        try {
            setSubmitting(true);
            const body = mapEnquiryDetails(postcodeData, enquiryValues);            
            await enquiry(body);
            eventTrackingHelper('enquiry');
            setForm(false);
            resetForm();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error occurred while sending enquiry');
        } finally {
            setSubmitting(false);
        }
    };

    const showAlertMessage = () => {
        const handleEnquiryLinkClick = (e) => {
            e.preventDefault();
            setForm(true);
        };

        return <Notice message={EQUIRY_SENT_NOTICE} onLinkClick={handleEnquiryLinkClick} />;
    }

    return (
        <div className="enquire-form-wrapper enquire-form--horizontal">
           
            <Formik
                initialValues={{
                    emailAddress: '',
                    contactNumber: '',
                    fullName: ''
                }}
                enableReinitialize={true}
                validationSchema={enquiryValidationSchema}
                onSubmit={handleSubmit}
            >
                {({ isValid, isSubmitting, errors, values, handleBlur, touched }) => {
                    return (
                        <>
                            {form && <Form autoComplete="off">
                                <p className="form-tite ">Talk to our brokers about your situation</p>
                                <div className="form-group">
                                    <Field
                                        type="input"
                                        name="fullName"
                                        placeholder="Full Name"
                                        value={values.fullName}
                                        onBlur={handleBlur}
                                        className="form-control input-val"
                                    />
                                    {touched.fullName && errors.fullName &&
                                        <div data-testid="testError" className="text-danger">{errors.fullName}</div>}
                                </div>

                                <div className="form-group">
                                    <Field
                                        type="input"
                                        name="contactNumber"
                                        placeholder="Contact Number"
                                        value={values.contactNumber}
                                        onBlur={handleBlur}
                                        className="form-control input-val"
                                    />
                                    {touched.contactNumber && errors.contactNumber && 
                                        <div data-testid="testError" className="text-danger">{errors.contactNumber}</div>}
                                </div>
                                <div className="form-group">
                                    <Field
                                        type="input"
                                        name="emailAddress"
                                        placeholder="Email Address"
                                        value={values.emailAddress}
                                        onBlur={handleBlur}
                                        className="form-control input-val"
                                    />
                                    {touched.emailAddress && errors.emailAddress && 
                                        <div data-testid="testError" className="text-danger">{errors.emailAddress}</div>}
                                </div>
                                <button
                                    id="calc-enquire-submit"
                                    className="btn-orange-enquiry btn loading-btn"
                                    type="submit"
                                    disabled={!isValid || isSubmitting || isEmpty(values)}
                                > SUBMIT 
                                    <Loader isLoading={isSubmitting} />
                                </button>

                            </Form>}
                            {!form && showAlertMessage()}
                        </>
                    );
                }}
            </Formik>
        </div>
    );
};

export default EnquiryForm;
